// Header names for forwarding geolocation to the API (match server GEO_HEADERS).
export const GEO_HEADERS = {
	CITY: "x-geo-city",
	COUNTRY: "x-geo-country",
	REGION: "x-geo-region",
	LATITUDE: "x-geo-latitude",
	LONGITUDE: "x-geo-longitude"
};

// Builds the x-geo-* request headers from a user geolocation object. Only
// present fields are included — absent/empty values are omitted so we never
// send a literal "undefined" (or empty) header value to the gateway.
export default function buildGeoHeaders(geolocation) {
	if (!geolocation) return {};
	const fields = [
		[GEO_HEADERS.CITY, geolocation.city],
		[GEO_HEADERS.COUNTRY, geolocation.country],
		[GEO_HEADERS.REGION, geolocation.region],
		[GEO_HEADERS.LATITUDE, geolocation.latitude],
		[GEO_HEADERS.LONGITUDE, geolocation.longitude]
	];
	return fields.reduce((headers, [name, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			headers[name] = String(value);
		}
		return headers;
	}, {});
}
